import { Box, Stack, Tooltip } from '@mui/material'
import { forwardRef, type ReactNode } from 'react'

export type SignalLevelProps = {
  rating: number
  scale: string[]
  filledColour?: string
  tooltipTitle?: ReactNode
  size?: 'sm' | 'md' | 'lg'
}

export const SignalLevel = forwardRef<HTMLDivElement, SignalLevelProps>(function SignalLevel(
  { rating, scale, filledColour = 'bg.neutral.default', tooltipTitle, size = 'md', ...props },
  ref
) {
  const cappedRating = Math.max(0, Math.min(rating, scale.length - 1))
  const height = { sm: '12px', md: '18px', lg: '24px' }[size]
  const barWidth = { sm: 2, md: 3, lg: 4 }[size]
  const gap = { sm: 0.5, md: 1, lg: 1 }[size]

  return (
    <Tooltip title={tooltipTitle ?? scale[cappedRating]}>
      <Stack direction="row" display="inline-flex" gap={gap} ref={ref} sx={{ height }} {...props}>
        {scale.slice(1).map((_, i) => (
          <Box
            key={i}
            sx={{
              borderRadius: 8,
              width: barWidth,
              backgroundColor: i < cappedRating ? filledColour : 'bg.neutral.muted',
            }}
          />
        ))}
      </Stack>
    </Tooltip>
  )
})
